/**
 * Shared helper used by every setup page to decide whether to hide the
 * "SETUP · STEP X OF 4" label in the page header.
 *
 * Once the merchant has finished all 4 onboarding steps, the linear
 * "step X of 4" framing stops being useful — they're just revisiting
 * the page to edit something. The label clutters the UI at that point.
 *
 * Must stay in sync with the `steps` array derivation in Dashboard.jsx.
 * If a step's "complete" criteria changes there, update it here too.
 */
export function isOnboardingComplete(status, packages) {
  if (!status) return false
  const course = status.course || {}
  const settings = status.settings || {}
  const hasLocation = !!(course.Latitude && course.Longitude)
  const hasProvider = !!settings.provider
  const hasPackages = Array.isArray(packages) && packages.length > 0
  const hasBranding = !!settings.branding && (
    !!settings.branding.logoUrl ||
    !!settings.branding.primaryColor ||
    !!settings.branding.style
  )
  return hasLocation && hasProvider && hasPackages && hasBranding
}
